import FullscreenModal from './FullscreenModal';

export default FullscreenModal;
